<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}

</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 1. 遮罩层背景模糊 + 深色半透明（不干扰弹窗内容清晰度） */
.el-overlay {
  backdrop-filter: blur(6px) !important;
  -webkit-backdrop-filter: blur(6px) !important;
  background-color: rgba(15, 23, 42, 0.45) !important; /* 深灰半透明，更高级 */
}

/* 2. 强制弹窗容器使用 Flex 居中对齐（覆盖掉 top / align-center 等个别差异） */
.el-overlay-dialog {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* 3. （可选）给弹窗本体增加一点微妙的进入动画，更平滑 */
.el-dialog {
  animation: dialogFadeIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) both;
  margin: 0 !important;
}

@keyframes dialogFadeIn {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
</style>